// extracted by mini-css-extract-plugin
module.exports = {"button":"link-block_button__hLoQ0","internal-icon":"link-block_internal-icon__CMRSJ"};